import { z } from 'zod';

import { salesAgentSchema } from './sales_agent_schema';

export const teacherAgentSchema = z.object({
  id: z.string(),
  approval: z.boolean(),
  // 現在の所属校が、この販売店の取り扱い校かどうか
  isHandledSchool: z.boolean().nullable().default(true),
  salesAgent: salesAgentSchema,
});

export type TeacherAgent = z.infer<typeof teacherAgentSchema>;
